module.exports = __webpack_public_path__ + "img/145.f802f063.jpg";